
import {defineComponent} from 'vue';
import {ICON_TYPES, ButtonType} from './types';
import {TYPE_BOOTSTRAP, TYPES} from '../Icon/types';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';

export default defineComponent({
  name: 'oxd-icon-button',

  components: {
    'oxd-icon': Icon,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    withContainer: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    displayType: {
      type: String,
      default: null,
      validator: function(value: ButtonType) {
        return !value || ICON_TYPES.indexOf(value) !== -1;
      },
    },
    iconType: {
      type: String,
      default: TYPE_BOOTSTRAP,
      validator: (value: string) => {
        return TYPES.indexOf(value) !== -1;
      },
    },
  },

  emits: ['click'],

  computed: {
    classes(): object {
      return {
        'oxd-icon-button': true,
        [`oxd-icon-button--${this.displayType}`]: Boolean(this.displayType),
      };
    },
  },

  methods: {
    onClick(e: Event) {
      e.preventDefault();
      this.$emit('click', e);
    },
  },
});
